var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ms-2"},[_c('button',{staticClass:"btn btn-utility",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"fa-light fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('G.LIT_Edit')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }